import axios from "axios";

const http = axios.create({
  baseURL: process.env.API_URL, // API URL Development
  // withCredentials: true,
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    console.error("Error response received", error.response);

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");

        if (refreshToken) {

          const { data } = await axios.get(`${process.env.API_URL}/refresh`, {
            headers: {
              Authorization: `Bearer ${refreshToken}`,
            },
          });

          localStorage.setItem("token", data.access_token);

          originalRequest.headers.Authorization = `Bearer ${data.access_token}`;

          return http(originalRequest);
        } else {
          console.error("No refresh token available");
        }
      } catch (refreshError) {
        console.error("Error during token refresh:", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default http;
